import ServiceLocator from 'live/services/service-locator'
import Utils from 'live/lib/utils'
import i18n from 'live/services/i18n'

const ERROR_MESSAGE = 'An error has occurred while migrating old purge rules!'

async function migrateOldPurgeRules(): Promise<void> {
    const migrationServiceUri = encodeURI('/services/plugin-purge-rules-migrator/migrate')
    const { credentials, headers } = Utils.fetchDefaults

    const response = await fetch(migrationServiceUri, {
        method: 'GET',
        credentials: credentials,
        headers: headers
    })

    if (!response.ok) throw Error(ERROR_MESSAGE)
}

const actionDef = {
    label: i18n('Migrate old purge rules'),
    callback: migrateOldPurgeRules,
    successMessage: i18n('Purge rules successfully migrated'),
    errorMessage: i18n(ERROR_MESSAGE),
    icon: 'fa-repeat'
}

try {
    ServiceLocator.getService('purge-extra-actions-registry').then(registry => {
        registry.register(actionDef)
    })
} catch (e) {
    console.error(e)
}
